
import { Component, Prop, Vue } from "vue-property-decorator"
import { SamlUrl } from "@/types/domain"

@Component({})
export default class OAuthLogin extends Vue {
	@Prop({ type: String, default: () => "" })
	facebookOauthUrl!: string

	@Prop({ type: Boolean, default: false })
	googleOAuthEnabled!: boolean

	@Prop({ type: String, default: () => "" })
	googleOauthUrl!: string

	@Prop({ type: Array, default: () => null })
	samlProviders!: SamlUrl[] | null

	@Prop({ type: Boolean, default: false })
	oauthLoginError!: boolean

	@Prop({ type: String, default: "" })
	oauthLoginErrorString!: string
}
